import React, { useEffect, useState } from "react";
import Loader from "./Loader";
import { TailSpin } from "react-loader-spinner";
import UserList from "./UserList";
import Pagination from "./Pagination";
import NavBar from "./Navbar";
import TopNavBar from "./TopNavbar";
import Search from "./Search";
import { fetchUsers, fetchUserCount, fetchPaySlipMetaList, addPropertiesData, deletePropertyMetaData } from "../services/UserService";
import "../styles/AdminPanel.css";
import axios from "axios";
import { Link } from "react-router-dom";
import addEmployeeIcon from "../images/addEmployeeIcon.svg";
import additionsIcon from "../images/additionsIcon.svg";
import { useAuth } from "../auth/auth";
import PaySlipMetaList from "./PayslipMetaList";
import {
  deniedActionClass,
  usePermissionGuard,
} from "../hooks/usePermissionGuard";
import { PERMISSIONS } from "../utils/rbac";
const apiUrl = process.env.REACT_APP_API_URL;

function PaySlipMetaData() {
  const { guardAction, PermissionDialog, isAllowed } = usePermissionGuard();
  const canCreateMetadata = isAllowed(PERMISSIONS.CREATE_METADATA);
  const [properties, setProperties] = useState([]);
  const [additions, setAdditionsType] = useState([]);
  const [deductions, setDeductionsType] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [typeMetaData, setType] = useState("");
  const [showAddModal, setShowAddModal] = useState(false);
  const [pageSize] = useState(15);
  const [searchResult, setSearchResult] = useState([]);
  const [showAllUsers, setShowAllUsers] = useState(true); // Track whether to show all users or search result
  const [isLoading, setIsLoading] = useState(true);
  const [name, setName] = useState("");
  const [triggerFetch, setTriggerFetch] = useState(false);
  const [loading, setLoading] = useState(false);

  useAuth();

//   const handleBlockUser = async (email) => {
//     try {
//       await axios.post("http://localhost:5000/block", { email });
//       const updatedUsers = users.map((user) => {
//         if (user.email === email) {
//           // Toggle the 'blocked' status
//           user.blocked = !user.blocked;
//         }
//         return user;
//       });
//       setUsers(updatedUsers);
//     } catch (error) {
//       //console.error("Failed to block/unblock user:", error);
//     }
//   }; 

  const handleDeleteAction = async (ID, type) => {
    // console.log(type);
    let confirmed = false;
    if(ID){
      confirmed = true;
    }
    if (confirmed) {
      try {
        const response = await deletePropertyMetaData(ID, type);
        // console.log(response);
        if(response.status == 1){
          setTriggerFetch((prev) => !prev);
        }else{
          alert(response.message);
        }
      } catch (error) {
        setLoading(false);
      } finally {
        setLoading(false);
        setIsLoading(false);
      }
    }
  };

  const confirmAddBox = async (type) => {
    guardAction(PERMISSIONS.CREATE_METADATA, `add ${type}`, () => {
      setType(type);
      setShowAddModal(true);
    });
  };

  const ConfirmAddModal = () => {
    return (
        <div className="popup-overlay" onClick={() => {
           setShowAddModal(false);
           setName(""); 
        }}>
          <div
            className="popup-container"
            onClick={(e) => e.stopPropagation()} // Prevent click from closing the modal
          >
           <img src={additionsIcon} style={{ display: "block", margin: "0 auto" , width:"45px"}} alt="Icon" />

            <h2 className="popup-title">Add {typeMetaData}</h2>
        <form>
            <input
              type="text"
              placeholder="Enter name"
              value={name}
              onChange={(e) => {
                // console.log("Typing:", e.target.value);
                setName(e.target.value);
              }}
              className="popup-input"
              autoFocus
            />
            
            <div className="popup-buttons">
              <button className="cancel-btn"   onClick={() => { 
                setShowAddModal(false);
                setName("");
                }}>
                Cancel
              </button>
    
              <button
                className="add-btn"
                onClick={() => {
                  handleAddData();
                  setShowAddModal(false);
                  setName("");
                }}
              >
                Add
              </button>
              
            </div>
            </form>
          </div>
        </div>
      );
  };

  const handleAddData = async () => {
    setLoading(true);
      try {
        const response = await addPropertiesData(typeMetaData, name);
        if(response.status == 1){
          setTriggerFetch((prev) => !prev);
        }else{
          alert(response.message);
        }
      } catch (error) {
        setLoading(false);
      } finally {
        setLoading(false);
        setIsLoading(false);
      }
    };

  const handleSearch = (searchResultUser) => {
    setSearchResult(searchResultUser); // Set the search result
    setShowAllUsers(false);
  };

  const handleShowAllUsers = () => {
    setShowAllUsers(true); // Set to true to display all users
    setSearchResult([]);
    //window.location.href = "/admin";//no need as useEffect re rendring page
  };

  const [count, setCount] = useState(0);

  useEffect(() => {
    async function fetchData() {
      const userCount = await fetchUserCount();
      setCount(userCount);
    }
    fetchData();
  }, []);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      try {
      
          const response = await fetchPaySlipMetaList();
          // console.log(response.additions);
            // setAdditionsType(response.additions)
            setAdditionsType(response.additions)
            setProperties(response.properties)
            setDeductionsType(response.deductions)
      } catch (error) {
       
      } finally {
        setLoading(false);
        setIsLoading(false);
      }
    }
    fetchData();
  }, [currentPage, pageSize, triggerFetch]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div className="admin-panel-parent-container">
          <PermissionDialog />
          <NavBar />
          <TopNavBar />
          {showAddModal && 
          <ConfirmAddModal />
        }
          <div className="admin-card admin-panel">
            <div className="admin-card-body">
            <div className="admin-header">
                <div className="left-section">
                  <h1 className="admin-header-title">
                    <span className="admin-card-title-span">
                     PaySlip Meta Data
                    </span>
                  </h1>
                </div>
               
              </div>
              {/* {searchResult.length > 0 && (
                <div className="show-all-users-container">
                  <button
                    onClick={handleShowAllUsers}
                    className="show-all-users-button"
                  >
                    Show All Users
                  </button>
                </div>
              )} */}
              {/* {loading && <Loader />} */}
              {loading && (
                <div className="spinner-container">
                  <TailSpin
                    type="TailSpin"
                    color="rgb(155, 236, 34)"
                    height={70}
                    width={70}
                    timeout={5000}
                  />
                </div>
              )}
              <div className="mainListWrapper">
              <div className="admin-header"  style={{
                        border: "none",
                        backgroundColor: "transparent",
                        marginTop:"15px"
                    }}>
                <div className="left-section">
                  <h1 className="admin-header-title">
                    <span className="admin-card-title-span">
                    Properties
                    </span>
                  </h1>
                </div>
                <div className="right-section">
                <Link
                    onClick={(e) => {
                      e.preventDefault();
                      confirmAddBox("properties");
                    }}
                    className={`add-user-link small-screen-link ${deniedActionClass(canCreateMetadata)}`}
                  >
                    <div className="add-user-container"
                      
                    >   
                      <img
                        src={addEmployeeIcon}
                        alt="Manage employee Icon"
                        className="addEmployeeIcon"
                      />
                      <span className="add-employee-text"> Add Properties</span>
                    </div>
                    </Link>
                </div>
              </div>
              
              <PaySlipMetaList
                users={properties}
                onDeleteUser={handleDeleteAction}
                currentPage={currentPage}
                type={"property"}
                pageSize={pageSize}
              />
               <div className="admin-header"  style={{
                        border: "none",
                        backgroundColor: "transparent",
                        marginTop:"15px"
                    }}>
                <div className="left-section">
                  <h1 className="admin-header-title">
                    <span className="admin-card-title-span">
                    Additions Type
                    </span>
                  </h1>
                </div>
                <div className="right-section">
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      confirmAddBox("additions");
                    }}
                    className={`add-user-link small-screen-link ${deniedActionClass(canCreateMetadata)}`}
                  >
                    <div className="add-user-container">
                      <img
                        src={addEmployeeIcon}
                        alt="Manage employee Icon"
                        className="addEmployeeIcon"
                      />
                      <span className="add-employee-text"> Add Additions</span>
                    </div>
                  </Link>
                </div>
              </div>

              <PaySlipMetaList
                users={additions}
                onDeleteUser={handleDeleteAction}
                currentPage={currentPage}
                type={"addition"}
                pageSize={pageSize}
              />

            <div className="admin-header"  style={{
                        border: "none",
                        backgroundColor: "transparent",
                        marginTop:"15px"
                    }}>
                <div className="left-section">
                  <h1 className="admin-header-title">
                    <span className="admin-card-title-span">
                    Deductions Type
                    </span>
                  </h1>
                </div>
                <div className="right-section">
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      confirmAddBox("deductions");
                    }}
                    className={`add-user-link small-screen-link ${deniedActionClass(canCreateMetadata)}`}
                  >
                    <div className="add-user-container">
                      <img
                        src={addEmployeeIcon}
                        alt="Manage employee Icon"
                        className="addEmployeeIcon"
                      />
                      <span className="add-employee-text"> Add Deductions</span>
                    </div>
                  </Link>
                </div>
              </div>
              <PaySlipMetaList
                users={deductions}
                onDeleteUser={handleDeleteAction}
                currentPage={currentPage}
                type={"deduction"}
                pageSize={pageSize}
              />
              </div>
              
            </div>
          </div>   
    </div>
  );
}

export default PaySlipMetaData;


//notification nai aani chaiye,socket msg nai aane